<template>
    <vue-scatter-chart
        :chart-data="chartData"
        :chart-options="chartOptions"
        :plugins="plugins"
    />
</template>

<script>
import { Scatter as VueScatterChart } from 'vue-chartjs/legacy'
import { BarController, BarElement, CategoryScale, Chart, Filler, Legend, LineElement, LinearScale, PointElement, Title, Tooltip } from 'chart.js'

Chart.register(BarController, BarElement, CategoryScale, Filler, Legend, LineElement, LinearScale, PointElement, Title, Tooltip)

export default {
    components: { VueScatterChart },
    props: {
        chartData: {type: Object},
        chartOptions: {type: Object},
        plugins: {type: Array},
    },
}
</script>